import styles from './styles.module.less';
import { AiIcon } from '../../ai/aiIcon/aiIcon';
import { Tooltip } from 'antd';
import { EditOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { RECOMMENDED_REPLY_EDIT_TRACKING_ID } from '@copilot/common/tracking/userpilotEventConsts';

type RecommendedMessageViewProps = Readonly<{
    onClick: () => void;
    message: string;
    style?: React.CSSProperties;
}>;

/**
 * A component that displays a recommended message
 * @param onClick - The function to call when the recommended message is clicked
 * @param message - The message to display
 * @param style - The style to apply to the component
 */
export function RecommendedMessageView({ onClick, message, style }: RecommendedMessageViewProps) {
    return (
        <div
            className={styles.recommendedMessagePreview}
            onClick={onClick}
            role="button"
            tabIndex={0}
            style={style}
            data-tracking-id={RECOMMENDED_REPLY_EDIT_TRACKING_ID}
        >
            <div className={styles.recommendedHeader}>
                <div className={styles.recommendedHeaderLeft}>
                    <span>Recommended Response</span>
                    <AiIcon />
                    <Tooltip title="Use our AI-suggested reply to respond faster and keep the conversation moving.">
                        <QuestionCircleOutlined style={{ marginLeft: '8px' }} />
                    </Tooltip>
                </div>
                <EditOutlined />
            </div>
            <div className={styles.recommendedBody}>{message}</div>
        </div>
    );
}
